import { IAnnualReportTemplateDTO } from '../interfaces/annual-report-template-dto.interface';

export type UpdateAnnualReportTemplateNotesTemplateIdDto = Pick<IAnnualReportTemplateDTO, 'id' | 'notesTemplateId'>;
